import { type AnyRouter, RouterProvider } from '@tanstack/react-router';

import { useCogniteClient } from '#core/hooks/useCogniteClient.ts';

export interface AppProps {
  router: AnyRouter;
}

export function App({ router }: AppProps) {
  const cogniteClient = useCogniteClient();
  return <RouterProvider context={{ cogniteClient }} router={router} />;
}
